/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2026 Prodeo - All Rights Reserved
 */

import { i18n } from '@umanforge/common';
import type { ChartHistory } from 'interfaces/chartOfSection.interface';

export const ADDITIONAL_INDICATOR_KEYS: Record<ChartHistory, string> = {
  none: '',
  moyenne: 'chart_indicator_moyenne',
  median: 'chart_indicator_median',
  cumul: 'chart_indicator_cumul',
  trend: 'chart_indicator_trend',
};

export const getIndicatorLabel = ( indicator: ChartHistory ): string => {
  const key = ADDITIONAL_INDICATOR_KEYS[ indicator ];
  return key ? i18n.t( key ) : '';
};

export const getWeekPrefix = (): string => {
  return i18n.t( 'chart_week_prefix', { defaultValue: 'W' } );
};

export enum AxisReadStartPrefix {
  Day    = 'd',
  Week   = 'w',
  Sprint = 's',
  Month  = 'm',
  Annual = 'a',
  Year   = 'y',
}
